import React from 'react'
import './icrs.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
//import JoinWaitlistButton from '../../Component/ViralLoops/JoinWaitlistButton';
import BetaWaitlist from '../../Component/Beta-Waitlist/BetaWaitlist.jsx';
import BoothPopup from '../../Component/BoothPopup/BoothPopup';
import BrochurePopup from '../../Component/BrochurePopup/BrochurePopup';


const Icrs = () => {
  return (
    
    <div>
      <AIheader/>
      
      <section className='landing_baner'>
  <div className="banner-inr">
    <h2>Welcome to <span>rentid</span>
    </h2>
    <p>at the</p>
    <img src="/img/car.png" alt="car-rental" />
    <p className="bnr-date">
      <span>April 14-16, 2025</span>
      <br /> Las Vegas, <span>NV</span>
    </p>
    <div className="bnr-btn">
    
        <BoothPopup buttonText=" Find Us at Booth 606" />
       
    </div>
    <div className="bnr-btn bnr-view">
    
        <BrochurePopup buttonText=" View Our 2025 Brochure" />
   
    </div>
  </div>
</section>
<section className="landing_waitlist">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="landing_waitlistInner">
          <h2>Join the Rentid Waitlist</h2>
          <p>The only rental platform you’ll ever need</p>
          <div className="landing_waitlist_formBtn">
            <div className="landing_waitlistbtn">
              <BetaWaitlist buttonClass="btn joinWaitBtn" buttonText="join Waitlist" />
              <img src="/img/arrow-up-right.svg" alt="icon" />
            </div>
          </div> {/* <div className="landing_waitlist_formBtn">
            <a className="landing_waitlistbtn" href="/">Join Waitlist <img src="/img/arrow-up-right.svg" alt="icon" />
            </a>
          </div> */}
        </div>
      </div>
    </div>
  </div>
</section>
<section className="landing_waitlist landing_gift">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="landing_waitlistInner">
          <h2>Claim my Gift</h2>
          <div className="landing_waitlist_formBtn">
            <a className="landing_waitlistbtn" target="_new" href="https://pages.viral-loops.com/icrs-claim-my-gift-1-uutuuluf">Claim Here <img src="/img/arrow-up-right.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="landing_waitlist landing_demo">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="landing_waitlistInner">
          <h2>Discover <span>rentid</span> demos </h2>
          <p>Experience Modern Rental</p>
          <div className="landing_waitlist_formBtn">
            <a className="landing_waitlistbtn" href="/explore-demo">Explore Demos <img src="/img/arrow-up-right.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className='techSolutionsMain landing_techSolutionsMain'>
  <div className='container'> {/* row start */} <div className="row justify-content-center">
      <div className="col-lg-12">
        <div className="techSolutionsHead">
          <h2>Technology solutions for your business</h2>
        </div>
      </div>
    </div> {/* row end */} {/* row start */} <div className="row justify-content-center">
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="techSolutionsInner">
          <div className="techHeading">
            <h3>Platform</h3>
          </div>
          <div className="techSolutionsData">
            <figure>
              <img className="img-fluid" src="/img/Technology/platform_icon.svg" alt="rent id" />
            </figure>
            <p>From on-board to on-rent in less <br />than 60 minutes, all in one place. </p>
            <a className="btn btnBlue" href="/platform">Learn More</a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="techSolutionsInner techSolutionsInner_2">
          <div className="techHeading">
            <h3>Marketplace</h3>
          </div>
          <div className="techSolutionsData">
            <figure>
              <img className="img-fluid" src="/img/Technology/map_icon.svg" alt="rent id" />
            </figure>
            <p>Your rental brand accessible to <br />renters anywhere & everywhere </p>
            <a className="btn btnBlue" href="/marketplace">Learn More</a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="techSolutionsInner techSolutionsInner_3">
          <div className="techHeading">
            <h3>Enterprise</h3>
          </div>
          <div className="techSolutionsData">
            <figure>
              <img className="img-fluid" src="/img/Technology/api_icon.svg" alt="rent id" />
            </figure>
            <p>Build with our rental workflows <br />designed to scale any business. </p>
            <a className="btn btnBlue" href="/enterprise">Learn More</a>
          </div>
        </div>
      </div>
    </div> {/* row end */} </div>
</section>
{/* <section className="landing_video">
  <div className="container">
    <div className="col-lg-12 col-md-12 col-sm-12 col-12 video_heading">
      <h2>Watch Rentid In Action</h2>
      <p>Product videos</p>
    </div>
    <div className="row">
      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 rentvideomain">
        <div className="rentideo">
          <img className="img-fluid" src="/img/action.png" alt="imng" />
        </div>
        <div className="rent-payicon">
          <img className="img-fluid" src="/img/play.svg" alt="imng" />
        </div>
        <div className="rent-text">
          <h3>Tutorial Videos for New Hosts</h3>
        </div>
      </div>
      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 rentvideomain">
        <div className="rentideo">
          <img className="img-fluid" src="/img/action.png" alt="imng" />
        </div>
        <div className="rent-payicon">
          <img className="img-fluid" src="/img/play.svg" alt="imng" />
        </div>
        <div className="rent-text">
          <h3>Best Practices for Filming Vehicle Listings</h3>
        </div>
      </div>
      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 rentvideomain">
        <div className="rentideo">
          <img className="img-fluid" src="/img/action.png" alt="imng" />
        </div>
        <div className="rent-payicon">
          <img className="img-fluid" src="/img/play.svg" alt="imng" />
        </div>
        <div className="rent-text">
          <h3>Step-by-Step Guides for Using the Rentid App</h3>
        </div>
      </div>
      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 rentvideomain">
        <div className="rentideo">
          <img className="img-fluid" src="/img/action.png" alt="imng" />
        </div>
        <div className="rent-payicon">
          <img className="img-fluid" src="/img/play.svg" alt="imng" />
        </div>
        <div className="rent-text">
          <h3>Success Stories from Top Hosts</h3>
        </div>
      </div>
    </div>
  </div>
</section> */}
<section className="landing_social">
  <div className="container">
    <div className="col-lg-12 col-md-12 col-sm-12 col-12 landing_social_inr">
      <h2>Follow us on social media</h2>
      <div className="landing_social-inr">
        <figure>
          <a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer">
            <img className="img-fluid" src="/img/facebook.svg" alt="rent id" />
          </a>
        </figure>
        <figure>
          <a href="https://www.instagram.com/rentid.io/" target="_blank" rel="noreferrer">
            <img className="img-fluid" src="/img/insta.svg" alt="rent id" />
          </a>
        </figure>
        <figure>
          <a href="https://www.linkedin.com/company/rentidinc/" target="_blank" rel="noreferrer">
            <img className="img-fluid" src="/img/linkdin.svg" alt="rent id" />
          </a>
        </figure>
        <figure>
          <a href="https://x.com/Rentid_" target="_blank" rel="noreferrer">
            <img className="img-fluid" src="/img/twitter.svg" alt="rent id" />
          </a>
        </figure>
      </div>
    </div>
  </div>
</section>
<section className='popularTopicsAnounceMain landing-platform'>
  <div className='container'> {/* row start */} <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="popularTopicsAnounceHeading">
          <h2>The Platform That Keeps Rentals Running</h2>
        </div>
      </div>
    </div> {/* row end */} {/* row start */} <div className="row justify-content-center">
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/direct.svg" alt="blog" />
            <h4>
              <span>rent</span>direct
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>Smart Booking Management</h3>
            <p>All-in-one booking system connected to a suite of rental workflows & tools unlike any other.</p>
            <a href="/rentdirect" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/shield.svg" alt="blog" />
            <h4>
              <span>rent</span>shield
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>Embedded Protection When Needed</h3>
            <p>Choose flexible insurance coverages and roadside assistance that turns on when the car goes out.</p>
            <a href="/rentshield" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/id.svg" alt="blog" />
            <h4>
              <span>rent</span>ID
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>Verify Every Guest, Instantly</h3>
            <p>Screen renters in seconds with ID, license, insurance checks and renter scoring. </p>
            <a href="/rentid" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/ai.svg" alt="blog" />
            <h4>
              <span>rentAI</span>
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>AI Rental Task Agent</h3>
            <p>AI rental agent that completes tasks, solves problems, & gets things done for your business. </p>
            <a href="/rentai" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/success.svg" alt="blog" />
            <h4>
              <span>rent</span>success
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>Built-In Support & Resolution Center</h3>
            <p>Dedicated support, real-time rental resolutions, and a focus on lasting customer loyalty.</p>
            <a href="/rentsuccess" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="popularTopicsAnounceInner">
          <figure>
            <img className="img-fluid" src="/img/academy.svg" alt="blog" />
            <h4>
              <span>rent</span>academy
            </h4>
          </figure>
          <div className="popularDataAnounce">
            <h3>On Demand Industry Education </h3>
            <p>Where experts drop knowledge & growth strategies on podcasts, articles, and video series,</p>
            <a href="/rentacademy" className="btn">
              <span>Learn more</span>
              <img src="/img/arrow_spl.svg" alt="icon" />
            </a>
          </div>
        </div>
      </div>
    </div> {/* row end */} </div>
</section> {/* START industryTrustMain */} <section className="industryTrustMain landingtrust">
  <div className="container">
    <div className='industryTrustOuter'>
      <div className='row align-items-center'>
        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
          <div className='industryTrustLeft'>
            <h2>Industry trust <span> and transparency</span>
            </h2>
          </div>
        </div>
        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
          <div className='industryTrustRight'>
            <ul>
              <li>
                <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
              </li>
              <li>
                <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
              </li>
              <li>
                <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> {/* END industryTrustMain */}





      <Footer/>
    </div>
  )
}

export default Icrs
